const changeFileExtension = (file, extension) => {
  if (!file) return null
  const splitFilename = file.split('.')
  const supportedImageExtensions = ['png', 'jpg', 'jpeg', 'webp']
  const unSupportedImageExtensions = ['gif', 'bmp', 'tiff', 'tif', 'svg', 'ico']
  const extensionIndex = splitFilename.length - 1
  const currentExtension = splitFilename[extensionIndex]
  if (unSupportedImageExtensions.includes(currentExtension)) return file
  if (!supportedImageExtensions.includes(currentExtension)) return file
  splitFilename[extensionIndex] = extension
  return splitFilename.join('.')
}

export default changeFileExtension
